import { render } from "./Experiment.vue?vue&type=template&id=6e0c7d86&ts=true"
import script from "./Experiment.vue?vue&type=script&lang=ts"
export * from "./Experiment.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__